<style>
@import '../../custom/css/cotacao.css';
</style>

<template>
  <div id="cotacao-enviada" class="cotacao" v-if="!checkIsEmpty(cotacao)">
    <div
      class="row"
      v-if="cotacao[0].cot_usuario_receb_resp_id === dadosUsuario.id"
    >
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">Orçamento Enviado</h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar o Orçamento"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result" v-if="cotacao[0].criado_em !== null">
                  {{ cotacao[0].criado_em }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div
                  class="cc-sub-result"
                  v-if="cotacao[0].cot_cotacao_id !== null"
                >
                  {{ cotacao[0].cot_cotacao_id }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div
                  class="cc-sub-result"
                  v-if="cotacao[0].cot_preferencia !== null"
                >
                  {{ cotacao[0].cot_preferencia }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Respondidos:
                <div class="cc-sub-result">
                  {{ quantProdutoRespondidos }} de {{ totalProdutos }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0" v-if="this.cotacao[0].produtos !== null">
            <div class="table-responsive">
              <h5 class="text-indent-5px">Inseridos pelo cliente</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Preço Unitário</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.produto_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome !== null">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.tipo_medida_nome !== null">
                        {{ produto.tipo_medida_nome }}
                      </div>
                      <div v-else>Sem medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <input
                        type="text"
                        v-bind:class="
                          'preco_unitario' +
                          [
                            produto.disponivel == true &&
                            produto.disponivel == 1 &&
                            produto.rejeitar !== true &&
                            produto.rejeitar !== 1
                              ? ''
                              : ' red-font',
                          ]
                        "
                        v-money="money"
                        v-model="produto.preco_unidades"
                        maxlength="14"
                      />
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <input
                        type="text"
                        v-bind:class="
                          'preco_unitario' +
                          [
                            produto.disponivel == true &&
                            produto.disponivel == 1 &&
                            produto.rejeitar !== true &&
                            produto.rejeitar !== 1
                              ? ''
                              : ' red-font',
                          ]
                        "
                        v-money="money"
                        :value="
                          subValor(
                            produto.preco_unidades,
                            produto.qtd_quantidade
                          )
                        "
                        readonly
                      />
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'disponivel' + index"
                          v-model="produto.disponivel"
                        />
                        <label
                          class="custom-control-label"
                          :for="'disponivel' + index"
                        >
                          <div v-if="produto.disponivel == true">Sim</div>
                          <div v-else>Não</div>
                        </label>
                      </div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="cc-content p-0"
            v-if="this.cotacao[0].produtosImagemArquivo !== null"
          >
            <div class="table-responsive">
              <h5 class="text-indent-5px">Produtos do arquivo</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Preço Unitário</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao[0].produtosImagemArquivo"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.produto_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome !== null">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.medida_nome !== null">
                        {{ produto.medida_nome }}
                      </div>
                      <div v-else>Sem medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <input
                        type="text"
                        v-bind:class="
                          'preco_unitario' +
                          [
                            produto.disponivel == true &&
                            produto.disponivel == 1 &&
                            produto.rejeitar !== true &&
                            produto.rejeitar !== 1
                              ? ''
                              : ' red-font',
                          ]
                        "
                        v-money="money"
                        v-model="produto.preco_unidades"
                        maxlength="14"
                      />
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <input
                        type="text"
                        v-bind:class="
                          'preco_unitario' +
                          [
                            produto.disponivel == true &&
                            produto.disponivel == 1 &&
                            produto.rejeitar !== true &&
                            produto.rejeitar !== 1
                              ? ''
                              : ' red-font',
                          ]
                        "
                        v-money="money"
                        :value="
                          subValor(
                            produto.preco_unidades,
                            produto.qtd_quantidade
                          )
                        "
                        readonly
                      />
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'disponivelai' + index"
                          v-model="produto.disponivel"
                        />
                        <label
                          class="custom-control-label"
                          :for="'disponivelai' + index"
                        >
                          <div v-if="produto.disponivel == true">Sim</div>
                          <div v-else>Não</div>
                        </label>
                      </div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content">
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div class="d-inline-block m-l-20px">
                  <a
                    :href="`${getImagesAddress}` + cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div
                class="col-4 p-0-left"
                v-if="checkIsEmpty(this.cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14"
                  >Retira na loja</b
                >
              </div>
              <div class="col-4 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14"
                  >CEP de entrega: {{ this.cotacao[0].cot_cep }}</b
                >
              </div>
              <div
                class="col-4 p-0 text-right"
                v-if="!checkIsEmpty(this.cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14">Frete:</b>
                <input
                  type="text"
                  :class="frete.class"
                  v-money="money"
                  v-model="cotacao[0].cot_frete"
                />
              </div>
              <div
                class="col-4 p-0 text-right"
                v-if="!checkIsEmpty(this.cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14"
                  >Prazo de entrega:</b
                >
                <input
                  type="date"
                  :class="prazo.class"
                  v-model="cotacao[0].cot_prazo_sem_mascara"
                />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="prazo-entrega text-right">
              <b class="font-weight-bold text-uppercase fs-14">Valor Total:</b>
              <input
                type="text"
                :class="frete.class"
                v-money="money"
                :value="valorTotal"
                readonly
              />
            </div>
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Condições de Pagamento:</b
              >
              <input
                type="text"
                :class="codicoes.class"
                v-model="cotacao[0].cot_cond_pagamentos"
              />
            </div>
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Orçamento válido até:</b
              >
              <input
                type="date"
                :class="orcamentodata.class"
                v-model="cotacao[0].cot_validade_sem_mascara"
              />
            </div>
          </div>
          <div class="cc-footer">
            <div class="position-relative p-10 text-right linha-abaixo-cinza">
              <div class="btn-enviar" @click="enviarRespostaCotacao()">
                Responder Cotação
              </div>
              <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
            </div>
            <div class="position-relative p-10 text-left">
              <div class="row m-0">
                <div class="col-1 p-0">
                  <div class="btn-rejeitar" @click="rejeitarCotacao()">
                    Rejeitar
                  </div>
                </div>
                <div class="col-11 p-0">
                  <div class="form-group row m-0">
                    <label
                      for="cotacaoRespostaMotivo"
                      class="col-sm-2 col-form-label text-right font-weight-bold text-uppercase fs-14"
                      >Motivos</label
                    >
                    <div class="col-sm-10 p-0">
                      <input
                        type="text"
                        :class="motivo.class"
                        id="cotacaoRespostaMotivo"
                        v-model="motivo.valor"
                        placeholder="Insira os motivos nesse campo caso vá rejeitar."
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row m-0"
      v-if="cotacao[0].cot_usuario_respondeu_id === dadosUsuario.id"
    >
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">Cotação Enviada</h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].atualizado_em }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].cot_cotacao_id }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].cot_preferencia }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Respondidos:
                <div class="cc-sub-result">
                  {{ quantProdutoRespondidos }} de {{ totalProdutos }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0" v-if="this.cotacao[0].produtos !== null">
            <div class="table-responsive">
              <h5 class="text-indent-5px">Inseridos pelo cliente</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.marca_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.tipo_medida_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td class="td">
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="cc-content p-0"
            v-if="this.cotacao[0].produtosImagemArquivo !== null"
          >
            <div class="table-responsive">
              <h5 class="text-indent-5px">Produtos do arquivo</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.cotacao[0]
                      .produtosImagemArquivo"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.marca_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.medida_nome }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td class="td">
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content">
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div class="d-inline-block m-l-20px">
                  <a
                    :href="`${getImagesAddress}` + cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div
                class="col-4 p-0-left"
                v-if="checkIsEmpty(this.cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14"
                  >Retira na loja</b
                >
              </div>
              <div class="col-4 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14"
                  >CEP de entrega: {{ this.cotacao[0].cot_cep }}</b
                >
              </div>
              <div
                class="col-4 p-0 text-right"
                v-if="!checkIsEmpty(this.cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14">Frete:</b>
                {{ this.cotacao[0].cot_frete }}
              </div>
              <div
                class="col-4 p-0 text-right"
                v-if="!checkIsEmpty(this.cotacao[0].cot_cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14"
                  >Prazo de entrega:</b
                >
                {{ this.cotacao[0].cot_prazo }}
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="prazo-entrega text-right">
              <b class="font-weight-bold text-uppercase fs-14">Valor Total:</b>
              {{ this.cotacao[0].cot_valor_total }}
            </div>
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Condições de Pagamento:</b
              >
              {{ this.cotacao[0].cot_cond_pagamentos }}
            </div>
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Orçamento válido até:</b
              >
              {{ this.cotacao[0].cot_validade }}
            </div>
          </div>
          <div class="cc-footer">
            <div
              class="position-relative row m-0 p-10 text-right linha-abaixo-cinza"
            >
              <div class="col-12 p-0 text-right">
                <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="comentarios" ref="comentarios" title="Comentarios" hide-footer>
      <template slot="modal-title">Dúvidas sobre esse produto</template>
      <div class="d-block text-center">
        <div class="limit_comentarios">
          <div
            class="comentarios_mensagens"
            v-for="(mensagem, index) in mensagensCotacao"
            :key="index"
          >
            <div
              class="row m-0"
              v-if="mensagem.usuario_enviador_id !== dadosUsuario.id"
            >
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
              <div class="mensagem col-9 p-0 text-left fs-14">
                {{ mensagem.mensagem }}
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="mensagem col-9 p-0 text-right fs-14">
                {{ mensagem.mensagem }}
              </div>
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
            </div>
          </div>
        </div>
        <div class="caixa_texto_mensagem">
          <div class="row m-0">
            <div class="col-9 p-j-right-10px">
              <textarea
                class="caixa_texto fs-12"
                placeholder="Digite sua dúvida e clique em anexar!"
                v-model="mensagem"
              ></textarea>
            </div>
            <div class="col-3 p-j-left-10px">
              <div
                class="btn btn-envio-mensagem"
                @click="
                  enviarMensagemProd(
                    dadosUsuario.id,
                    cotacao[0].id,
                    dadosUsuario.id !== cotacao[0].cot_usuario_respondeu_id
                      ? cotacao[0].cot_usuario_respondeu_id
                      : cotacao[0].cot_usuario_receb_resp_id
                  )
                "
              >
                Anexar
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('comentarios')"
        >Fechar</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DownloadImages from '../../components/DownloadImages';

export default {
  name: 'cotacao-enviada',
  components: {
    DownloadImages,
  },
  data: () => ({
    items: [],
    errors: [],
    mensagem: null,
    mensagemProdId: null,
    motivo: {
      valor: null,
      mensagem: null,
      class: 'form-control',
    },
    frete: {
      valor: '',
      mensagem: null,
      class: 'form-control frete-input',
    },
    prazo: {
      valor: null,
      mensagem: null,
      class: 'datepicker',
    },
    valor_total: {
      valor: null,
      mensagem: null,
      class: 'form-control valor-total-input',
    },
    codicoes: {
      valor: null,
      mensagem: null,
      class: 'form-control codicoes-input',
    },
    orcamentodata: {
      valor: null,
      mensagem: null,
      class: 'datepicker',
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: true,
    },
  }),
  props: ['id'],
  created() {
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacao').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacaoRespondida', this.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacaoRespondida', this.id)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      valorTotal: (state) => {
        let valorTotal = 0;
        const valorFrete = String(state.cotacao[0].cot_frete);

        if (state.cotacao[0].produtos !== null) {
          for (const produto in state.cotacao[0].produtos) {
            let valorString = String(
              state.cotacao[0].produtos[produto].preco_unidades
            );
            if (
              state.cotacao[0].produtos[produto].disponivel == true &&
              state.cotacao[0].produtos[produto].rejeitar == false
            ) {
              valorString = parseFloat(valorString.replace(/[\D]+/g, ''));

              valorTotal +=
                parseFloat(valorString) *
                parseFloat(state.cotacao[0].produtos[produto].qtd_quantidade);
            }
          }
        }

        if (state.cotacao[0].produtosImagemArquivo !== null) {
          for (const produto in state.cotacao[0].produtosImagemArquivo) {
            let valorString = String(
              state.cotacao[0].produtosImagemArquivo[produto].preco_unidades
            );
            if (
              state.cotacao[0].produtosImagemArquivo[produto].disponivel ==
                true &&
              state.cotacao[0].produtosImagemArquivo[produto].rejeitar == false
            ) {
              valorString = parseFloat(valorString.replace(/[\D]+/g, ''));
              valorTotal +=
                parseFloat(valorString) *
                parseFloat(
                  state.cotacao[0].produtosImagemArquivo[produto].qtd_quantidade
                );
            }
          }
        }

        valorTotal =
          parseFloat(valorTotal) + parseFloat(valorFrete.replace(/[\D]+/g, ''));

        return valorTotal;
      },
      mensagensCotacao: (state) => state.mensagensCotacao,
      totalProdutos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;
          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              quantProdutos += state.cotacao[0].produtos.length;
            }
          }

          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              quantProdutos += state.cotacao[0].produtosImagemArquivo.length;
            }
          }

          return quantProdutos;
        }
      },
      quantProdutoRespondidos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;

          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              for (const produto in state.cotacao[0].produtos) {
                if (
                  (state.cotacao[0].produtos[produto].disponivel === 1 ||
                    state.cotacao[0].produtos[produto].disponivel === true) &&
                  (state.cotacao[0].produtos[produto].rejeitar === 0 ||
                    state.cotacao[0].produtos[produto].rejeitar === false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }

          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              for (const produto in state.cotacao[0].produtosImagemArquivo) {
                if (
                  (state.cotacao[0].produtosImagemArquivo[produto]
                    .disponivel === 1 ||
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .disponivel === true) &&
                  (state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                    0 ||
                    state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                      false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }

          return quantProdutos;
        }
      },
    }),
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    voltarCotacao() {
      this.$router.push({
        name: 'lojista-enviadas',
      });
    },
    retirarAvisos() {
      this.errors = [];
      this.motivo.class = 'form-control';
      this.frete.class = 'form-control frete-input';
      this.prazo.class = 'datepicker';
      this.valor_total.class = 'form-control valor-total-input';
      this.codicoes.class = 'form-control codicoes-input';
      this.orcamentodata.class = 'datepicker';
    },
    verMensagens(UsuarioEnviador, produtoId, UsuarioRecebedor) {
      const data = {
        id: produtoId,
        usuarioId: UsuarioEnviador,
      };

      this.mensagemProdId = produtoId;

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('showMensagensCotacaoRespostaAtt', data)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            this.$bvModal.show('comentarios');
          }, 1500);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
        });
    },
    enviarMensagemProd(UsuarioEnviador, cotacaoId, UsuarioRecebedor) {
      const self = this;
      const data = {
        usuario_enviador_id: UsuarioEnviador,
        cotacao_resposta_id: cotacaoId,
        cotacao_produto_id: this.mensagemProdId,
        usuario_recebedor_id: UsuarioRecebedor,
        mensagem: this.mensagem,
      };

      this.$store.dispatch('insertMensagem', data).then(() => {
        setTimeout(() => {
          if (this.getTipoNotification == 1) {
            this.aviso('Sua dúvida foi anexada com sucesso! ', 'success');
          } else if (this.getTipoNotification == 3) {
            this.aviso(this.getNotification, 'danger');
          }
          this.$store.dispatch(
            'showMensagensCotacaoResposta',
            self.mensagemProdId
          );
          this.mensagem = null;
        }, 1000);
      });
    },
    enviarRespostaCotacao() {
      const self = this;
      this.retirarAvisos();
      if (this.checkIsEmpty(this.cotacao[0].cot_frete)) {
        this.frete.class += ' error-form';
        this.errors.push('o frete');
      }

      if (this.checkIsEmpty(this.cotacao[0].cot_prazo_sem_mascara)) {
        this.prazo.class += ' error-form';
        this.errors.push('o prazo');
      }

      if (this.checkIsEmpty(this.valorTotal)) {
        this.valor_total.class += ' error-form';
        this.errors.push('o valor total');
      }

      if (this.checkIsEmpty(this.cotacao[0].cot_cond_pagamentos)) {
        this.codicoes.class += ' error-form';
        this.errors.push('as condições de pagamento');
      }

      if (this.checkIsEmpty(this.cotacao[0].cot_validade_sem_mascara)) {
        this.orcamentodata.class += ' error-form';
        this.errors.push('a data de orçamento valido');
      }

      if (this.errors.length === 0) {
        const produtosAlt = [];

        if (this.cotacao[0].produtos !== null) {
          for (const item of this.cotacao[0].produtos) {
            produtosAlt.push(item);
          }
        }

        if (this.cotacao[0].produtosImagemArquivo !== null) {
          for (const item of this.cotacao[0].produtosImagemArquivo) {
            produtosAlt.push(item);
          }
        }

        for (const produto of produtosAlt) {
          produto.precoAlt = this.unsMaskValor(produto.preco_unidades);
        }

        const dadosResposta = {
          cotacao_id: this.id,
          usuario_enviador_id: this.dadosUsuario.id,
          usuario_recebedor_id: this.cotacao[0].cot_usuario_id,
          produtos: produtosAlt,
          condicoes_de_pagamento: this.cotacao[0].cot_cond_pagamentos, // Condições para o pagamento
          valor_total: this.unsMaskValor(this.valorTotal),
          frete: this.unsMaskValor(this.cotacao[0].cot_frete),
          prazo: this.cotacao[0].cot_prazo_sem_mascara,
          validade: this.cotacao[0].cot_validade_sem_mascara,
        };

        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('updateCotacaoRespostaDetalhes', dadosResposta)
          .then((data) => {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso('Resposta enviada com sucesso!', 'success');
              setTimeout(() => {
                self.$router.push({ name: 'lojista-enviadas' });
              }, 1000);
            }, 1500);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.aviso(
              'Não foi possível enviar uma resposta! Tente Novamente em 5 minutos!'
            );
          });
      } else {
        this.$store.dispatch('endLoader');
        for (const erro in this.errors) {
          this.aviso(
            `É necessário colocar '${this.errors[erro]}' para enviar a resposta`,
            'warning'
          );
        }
      }
    },
    rejeitarCotacao() {
      if (this.checkIsEmpty(this.motivo.valor)) {
        this.aviso(
          'É necessário escrever o motivo para rejeitar essa cotação!',
          'warning'
        );
      } else {
        const values = {
          id: this.cotacao[0].id,
          idCotacao: this.cotacao[0].cot_cotacao_id,
          motivo_rejeicao: this.motivo.valor,
          usuario_enviador_id: this.dadosUsuario.id,
          usuario_recebedor_id:
            this.dadosUsuario.id !== this.cotacao[0].cot_usuario_receb_resp_id
              ? this.cotacao[0].cot_usuario_receb_resp_id
              : this.cotacao[0].cot_usuario_respondeu_id,
        };

        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('updateCotacaoRejeitacao', values)
          .then((data) => {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              if (this.getTipoNotification == 1) {
                this.aviso(this.getNotification, 'success');
                setTimeout(() => {
                  this.$router.push({
                    name: 'lojista-rejeitadas-pelo-usuario',
                  });
                }, 1500);
              } else if (this.getTipoNotification == 3) {
                this.aviso(this.getNotification, 'danger');
              }
            }, 1000);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },
    subValor(valor, quantidade) {
      let valorString = String(valor);
      valorString =
        parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(quantidade);
      return valorString;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
